/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Motivation_TitleInputs */

const en_us2_profile_editors_motivation_title = /** @type {(inputs: Profile_Editors_Motivation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What motivates you most to train?`)
};

const pt_br2_profile_editors_motivation_title = /** @type {(inputs: Profile_Editors_Motivation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que mais te motiva a treinar?`)
};

const es_419_profile_editors_motivation_title = /** @type {(inputs: Profile_Editors_Motivation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es lo que más te motiva a entrenar?`)
};

const pt_pt2_profile_editors_motivation_title = /** @type {(inputs: Profile_Editors_Motivation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que mais te motiva a treinar?`)
};

const fr_fr2_profile_editors_motivation_title = /** @type {(inputs: Profile_Editors_Motivation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qui te motive le plus à t'entraîner ?`)
};

const de_de2_profile_editors_motivation_title = /** @type {(inputs: Profile_Editors_Motivation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was motiviert dich am meisten zum Training?`)
};

const it_it2_profile_editors_motivation_title = /** @type {(inputs: Profile_Editors_Motivation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa ti motiva di più ad allenarti?`)
};

/**
* | output |
* | --- |
* | "What motivates you most to train?" |
*
* @param {Profile_Editors_Motivation_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_motivation_title = /** @type {((inputs?: Profile_Editors_Motivation_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Motivation_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_motivation_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_motivation_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_motivation_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_motivation_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_motivation_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_motivation_title(inputs)
	return en_us2_profile_editors_motivation_title(inputs)
});
export { profile_editors_motivation_title as "profile-editors.motivation_title" }